// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","945":"dashboard"}[chunkId] || chunkId) + "-legacy." + {"76":"17ad9cb4","919":"b19222fe","945":"8fe2e611"}[chunkId] + ".js";
};